
var stache = require('can/view/stache/stache');
module.exports = stache("<div {{#unless isEmbed}}class=\"c-animation-item c-animation-item--{{timelineType}}\"{{/unless}} data-visible=\"{{visible}}\" data-transition=\"{{transition}}\">\r\n    <content/>\r\n</div>");